
      <div 
        class="btn-group dropdown-group" 
        dropdown #houseDrop="bs-dropdown" [autoClose]="false">
          
        <input #houseControl="ngModel" type="text" 
          class="routeInputs inline-block inputShorted " 
          id="house" name="hse" #houseInput placeholder="Введіть номер будинку та виберіть зі списку" 
          (keyup)="houseNumberTyped()" [(ngModel)]="house" autocomplete="off" />

        <ul [hidden]="! ( isShowHousesList && isCloseHousesPresent() )" id="dropdown-triggers-manual" *dropdownMenu class="houses-dropdown-menu"
            role="menu" aria-labelledby="button-triggers-manual">
          <div role="menuitem" *ngFor="let house of closeHouses" >
            <button type="button" class="dropdown-item" id="{{'H'+house.HOUSENUMBER_UA}}"
            (click)="selectHouse( house, $event.target.innerText ); isShowHousesList = false; "  >
              {{ toUpper( house.HOUSENUMBER_UA ) }}
            </button>
          </div>
          
        </ul>

        <button type="button" [disabled]="! isCloseHousesPresent() "
          [ngClass]="dropdownButtonClass"  
          class="btn btn-white dropdown-toggle-split dropButton greyDropdown" 
          (click)=" isShowHousesList = ! isShowHousesList ; "
          formnovalidate="formnovalidate" >
            <i class="fas fa-caret-down"></i>
        </button>

  